import {useEffect} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {useHistory, useParams} from 'react-router'

import {useTranslation} from '../../../../hooks/useTranslation'

import {SlotManagementConfigurationDetails} from './components/SlotManagementConfigurationDetails'
import {useSlotManagementConfigsEditMutation} from './hooks/useSlotManagementConfigsMutation'
import {useSlotManagementConfigsQuery} from './hooks/useSlotManagementConfigsQuery'
import {SlotManagementConfig} from './types/SlotManagementConfig'

export const SlotManagementConfigurationEdit = () => {
  const {configId} = useParams<{
    configId?: string
  }>()

  const {t} = useTranslation()
  const history = useHistory()
  const slotManagementConfigsMutation = useSlotManagementConfigsEditMutation()

  const slotManagementConfigQueryInfo = useSlotManagementConfigsQuery()

  const methods = useForm<SlotManagementConfig>({
    defaultValues: {} as SlotManagementConfig,
    mode: 'onChange'
  })

  useEffect(() => {
    if (configId && slotManagementConfigQueryInfo.data) {
      const config = slotManagementConfigQueryInfo.data.find((config) => config.id === configId)
      if (config) {
        methods.reset(config)
      }
    }
  }, [configId, slotManagementConfigQueryInfo.data, methods])

  const handleSaveButtonClick = async (data: SlotManagementConfig) => {
    try {
      await slotManagementConfigsMutation.mutateAsync(data)
    } finally {
      history.goBack()
    }
  }

  if (slotManagementConfigQueryInfo.isLoading || !slotManagementConfigQueryInfo.data) {
    return <div>{t('configurations.hconnect.slotManagement.configurationDetails.loading')}</div>
  }

  return (
    <FormProvider {...methods}>
      <SlotManagementConfigurationDetails
        mode="edit"
        configId={configId}
        onSaveButtonClick={methods.handleSubmit(handleSaveButtonClick)}
        isSubmitting={slotManagementConfigsMutation.isLoading}
      />
    </FormProvider>
  )
}
